import React from 'react';

const FLOWS = [
    { tone: '1', step: 'All applicants free', title: 'Free readiness profile', body: 'Generate goodwill. Following application via web form from your website, every applicant is offered a free investment readiness check whilst awaiting your initial gating. No cost, no commitment.' },
    { tone: '2', step: 'Rejected applicants', title: 'A warm handover, not a dead end', body: "Every company you don't accept is introduced to Diligentsia's broader network — matched to other VCs, advisors, and programmes. Your brand stays associated with a constructive outcome." },
    { tone: '3', step: 'Successful cohort invitees', title: 'Onboarded from day one', body: 'Every company you accept begins their Diligentsia journey as part of onboarding. By demo day: a completed Diligence Pack, Bronze/Silver/Gold certification, and 1-click access to 40+ VCs.' },
];

const AccFlowsSection = () => (
    <section className="lp-acc-sec">
        <div className="lp-acc-wrap">
            <span className="lp-acc-kicker" data-lp-reveal>How the partnership works</span>
            <h2 className="lp-acc-h2" data-lp-reveal data-lp-delay="60">Three flows, one platform — practical and low-friction for both sides.</h2>

            <div className="lp-acc-flows">
                {FLOWS.map((f, i) => (
                    <div className={`lp-acc-flow is-${f.tone}`} key={f.title} data-lp-reveal data-lp-delay={i * 90}>
                        <div className="lp-acc-flow-step">{f.step}</div>
                        <h4>{f.title}</h4>
                        <p>{f.body}</p>
                    </div>
                ))}
            </div>
        </div>
    </section>
);

export default AccFlowsSection;
